import styled from "styled-components";
import {useLocale} from "next-intl";
import {useGetPatentQuery} from "@/api/patentApi";
import {SIZES} from "@/components/constants";

const PatentSection = ({data}) => {
    const locale = useLocale();
    const { data: patentData, isLoading } = useGetPatentQuery({locale});
    return(
        <>
            {
                !isLoading && patentData &&
                <SectionWrap>
                    <div className={"container"}>
                        <h2 className={"title"} dangerouslySetInnerHTML={{__html: data["patent-text"]}}/>
                        <ul className={"patent-wrap"}>
                            {
                                patentData.result && patentData.data && patentData.data.length > 0 &&
                                patentData.data.map((item, idx) =>
                                    <li
                                        className={"item"}
                                        key={idx}
                                    >
                                        <div>
                                            <img src={item?.File?.url} alt={item?.title}/>
                                        </div>
                                        <span>{item?.title}</span>
                                    </li>
                                )
                            }
                        </ul>
                    </div>
                </SectionWrap>
            }
        </>
    )
}

const SectionWrap = styled.section`
    padding: 96px 0;
    .container{
        gap: 48px;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        display: flex;
        margin: 0 auto;
        padding: 0 20px;
        .title{
            font-weight: 700;
            font-size: 18px;
            line-height: 64px;
        }
        .patent-wrap{
            gap: 20px;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            display: grid;
            .item{
                gap: 3px;
                align-items: center;
                flex-direction: column;
                display: flex;
            }
        }
    }
    @media (min-width: ${SIZES.MOBILE}) {
        .container {
            max-width: 640px;
            .patent-wrap{
                gap: 36px;
                grid-template-columns: repeat(3, minmax(0, 1fr));
            }
        }
    }
    @media (min-width: ${SIZES.MOBILE_L}) {
        .container {
            max-width: 768px;
        }
    }
    @media (min-width: ${SIZES.TABLET}) {
        padding: 120px 0;
        .container {
            max-width: 1024px;
            .title{
                font-size: 40px;
            }
            .patent-wrap{
                grid-template-columns: repeat(4, minmax(0, 1fr));
                .item{
                    gap: 16px;
                }
            }
        }
    }
    @media (min-width: ${SIZES.TABLET_L}) {
        .container {
            max-width: 1280px;
        }
    }
    @media (min-width: ${SIZES.PC}) {
        .container {
            max-width: 1536px;
        }
    }
`
export default PatentSection;